export default {
  descricao: {
    value: '',
    maxlength: '70',
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/pa/components/search/search-form.js